<script>

import CommonConstants from '@/common/Constants';
import Utils from '@/common/Utils';
import ResponsiveButton from '@/components/generic/ResponsiveButton.vue';
import Service from '@/services/planning'
import DataTable from 'primevue/datatable';
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import ColumnGroup from 'primevue/columngroup';   // optional
import Row from 'primevue/row';                   // optional
export default {
    components: {
        ResponsiveButton
        ,GenericCustomMasterDataAutocompleteV2
        ,ColumnGroup
        ,Row
    },
    data(){
        return{
            
            backgroundColor: ["#42A5F5","#66BB6A","#FFA726"],
            hoverBackgroundColor: ["#64B5F6","#81C784","#FFB74D"],
            activeTab: 0,
            lastActiveTab: 0,
            filters: {
                dataStocchino: null
            },
            automaticCalculateSplitButtonItems: [
                {
                    label: this.$t('StocchinoPlan.recalculate'),
                    command: () => {
                        this.recalculateAuto();
                    }
                },
                {
                    label: this.$t('StocchinoPlan.importAndRecalculate'),
                    command: () => {
                        this.importAndRecalculate();
                    }
                },
            ],
            dirty: false,
            autoItems: [],
            familyStorageItems: [],
            inventoryItems: [],
            minMaxWsItems: [],
            autoLoading: false,
            familyStorageLoading: false,
            inventoryLoading: false,
            minMaxWsLoading: false,
            autoUpdateList: [],
            inventoryUpdateList: [],
            minMaxWsUpdateList: [],
            autoHeaderId: null,
            inventoryHeaderId: null,
            minMaxWsHeaderId: null,
            updateTargetDialogVisible: false,
            updateFamilyDialogVisible: false,
            updateOwnerCompanyDialogVisible: false,
            productAggregationComboProductLevelValue: null,
            productAggregationComboFamilyLevelValue: null,
            ownerCompanyLevelValue: null,
            editItem: null,
            productAggregationSelected: null,
            familyAggregationSelected: null,
            companySelected: null,
            autoSaveWarnings: [],
            autoSaveWarningsDialogVisible: false,
            inventoryShowSummary: false,
            exportMinMaxWSVisible: false,
            exportMinMaxWS: {},
            tankContent: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: ["#42A5F5","#66BB6A","#FFA726", "#be5683", "#af4154"],
                        hoverBackgroundColor: ["#64B5F6","#81C784","#FFB74D", "#db0a5b", "#96281b"]
                    }
                ]
            },
            tankContentOptions: {
                plugins: {
                    legend: {
                        position: 'right'
                    }
                },
            },
            tankContentVisible: false,
            tankCompositionTitle: ''
        }
    },
    created(){
        this.$store.dispatch('security/setNavbarTitle', 'StocchinoPlan.page_title');
    },
    mounted(){
        
    },
    methods: {
        load(){
            this.loadAuto();
            this.loadProductFamilyStorage();
            this.loadInventory();
            this.loadMinMaxWs();
        },
        loadAuto(){
            this.autoHeaderId= null;
            this.autoLoading = true;
            this.autoItems = [];
            this.autoUpdateList = [];
            let body = {
                dataStocchino: Utils.formatDateForAPI(this.filters.dataStocchino)
            }
            Service.loadStocchinoPlanAuto(body, response => {
                this.autoLoading = false;
                if(response.success){
                    this.autoItems = response.data;
                    this.autoItems.sort((a,b) => {
                        return b.site.localeCompare(a.site) || a.order - b.order;
                    })
                    if(response.data.length > 0){
                        this.autoHeaderId = response.data[0].headerId;
                    }
                }
            });
        },
        loadMinMaxWs(){
            this.minMaxWsHeaderId= null;
            this.minMaxWsLoading = true;
            this.minMaxWsItems = [];
            this.minMaxWsUpdateList = [];
            let body = {
                dataStocchino: Utils.formatDateForAPI(this.filters.dataStocchino)
            }
            Service.loadStocchinoPlanMinMaxWS(body, response => {
                this.minMaxWsLoading = false;
                if(response.success){
                    this.minMaxWsItems = response.data;
                    this.minMaxWsItems.sort((a,b) => {

                        return b.ownerCompanyDescription.localeCompare(a.ownerCompanyDescription) || parseFloat(a.ordine) - parseFloat(b.ordine);

                        // let aFloat = parseFloat(a.ordine)
                        // let bFloat = parseFloat(b.ordine)
                        // return aFloat - bFloat;
                    })
                    if(response.data.length > 0){
                        this.minMaxWsHeaderId = response.data[0].headerId;
                    }
                }
            });
        },
        recalculateAuto(){
            this.$store.dispatch("generic/setLoading", true);
            this.autoSaveWarnings = [];
            let dataStocchino = Utils.formatDateForAPI(this.filters.dataStocchino);
            Service.recalculateStocchinoPlan(dataStocchino, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.load();
                    if(response.warnings && response.warnings.length > 0){
                        this.$toast.add({detail: this.$t('StocchinoPlan.saveHasWarnings'), life:3000, severity:'warn'});
                    }
                    this.autoSaveWarnings = response.warnings;
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            });
        },
        importAndRecalculate(){
            this.$confirm.require({
                message: this.$t('StocchinoPlan.importAndRecalculateMessage'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.$store.dispatch("generic/setLoading", true);
                    let dataStocchino = Utils.formatDateForAPI(this.filters.dataStocchino);
                    Service.processTankExceptionsStocchinoPlan(dataStocchino, resp => {
                        if(resp.success){
                            Service.createStocchinoPlan(dataStocchino, response => {
                                this.$store.dispatch("generic/setLoading", false);
                                if(response.success){
                                    this.load();
                                    if(response.warnings && response.warnings.length > 0){
                                        this.$toast.add({detail: this.$t('StocchinoPlan.saveHasWarnings'), life:3000, severity:'warn'});
                                    }
                                    this.autoSaveWarnings = response.warnings;
                                }else{
                                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                }
                            });
                        }else{
                            this.$store.dispatch("generic/setLoading", false);
                            this.$toast.add({detail: resp.message && resp.message != '' ? resp.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    });
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });

            
        },
        loadProductFamilyStorage(){
            this.familyStorageLoading = true;
            this.familyStorageItems = [];
            let body = {
                dataStocchino: Utils.formatDateForAPI(this.filters.dataStocchino)
            }
            Service.loadStocchinoPlanStorage(body, response => {
                this.familyStorageLoading = false;
                if(response.success){
                    this.familyStorageItems = response.data;
                    this.familyStorageItems.sort((a,b) => {
                        // return this.convertFamilyDescriptionForStorage(a).localeCompare(this.convertFamilyDescriptionForStorage(b));
                        return b.site.localeCompare(a.site) || a.ordine - b.ordine;
                    })
                }
            });
        },
        familyStorageGroupBy(item){
            return this.convertFamilyDescriptionForStorage(item);
        },
        inventoryGroupBy(item){
            return "";
        },
        loadInventory(){
            this.inventoryHeaderId = null;
            this.inventoryLoading = true;
            this.inventoryItems = [];
            this.inventoryUpdateList = [];
            let body = {
                dataStocchino: Utils.formatDateForAPI(this.filters.dataStocchino)
            }
            Service.loadStocchinoPlanInventory(body, response => {
                this.inventoryLoading = false;
                if(response.success){
                    this.inventoryItems = response.data;
                    this.inventoryItems.sort((a,b) => {
                        return b.ownerCompanyDescription.localeCompare(a.ownerCompanyDescription) || parseFloat(a.ordine) - parseFloat(b.ordine);

                        // let aFloat = parseFloat(a.ordine)
                        // let bFloat = parseFloat(b.ordine)
                        // return aFloat - bFloat;
                    });
                    
                    if(response.data.length > 0){
                        this.inventoryHeaderId = response.data[0].headerId;
                    }
                }
            });
        },
        convertFamilyDescription(record) {
            let site = record.site == 'ISABNORD' ? 2 : 1;
            let order = record.order < 10 ? ('0' + record.order) : record.order; 

            return `Family: ${site}.${order} - ${record.stockFamilyDescription}`;
        },
        convertFamilyDescriptionForStorage(record) {
            let site = record.site == 'ISABNORD' ? 2 : 1;
            let order = record.ordine < 10 ? ('0' + record.ordine) : record.ordine; 

            return `Family: ${site}.${order} - ${record.stockFamilyParentDescription}`;
        },
        setOutOfService(data){
            data.isFuoriServizio = !data.isFuoriServizio;
            let found = this.autoUpdateList.find(item => item.rowID == data.id);
            if(found){
                found.isFuoriServizioNew = data.isFuoriServizio;
            }else{
                this.autoUpdateList.push({
                    rowID: data.id,
                    isFuoriServizioNew: data.isFuoriServizio
                });
            }
        },
        showEditTarget(data){
            this.editItem = data;
            this.productAggregationSelected = null;
            this.familyAggregationSelected = null;
            this.productAggregationComboProductLevelValue = null;
            this.productAggregationComboFamilyLevelValue = null;
            this.updateTargetDialogVisible = true;
        },
        showEditCompany(data){
            this.editItem = data;
            this.ownerCompanyLevelValue = null;
            this.companySelected = null;
            this.updateOwnerCompanyDialogVisible = true;
        },
        onProductSelected(item){
            this.productAggregationSelected = item;
            this.$refs.productAggregationComboFamilyLevel.forceLoadOptions(`stocchino-plan-registry/product-aggregation-combo-familylevel?dataRif=${this.refDate}&site=${this.editItem.site}&idProdotto=${item.value}`)
        },
        onFamilySelected(item){
            this.familyAggregationSelected = item;
        },
        onCompanySelected(item){
            this.companySelected = item;
        },
        setProductAndFamily(){
            this.editItem.target = this.productAggregationSelected.label;
            let found = this.autoUpdateList.find(item => item.rowID == this.editItem.id);
            if(found){
                found.oldStockFamilyID = this.editItem.stockFamilyId;
                    found.newStockFamilyID = this.familyAggregationSelected.value;
                    found.oldProductID = this.editItem.idProdottoSim;
                    found.newProductID = this.productAggregationSelected.value;
                    found.target = this.editItem.target;
            }else{
                this.autoUpdateList.push({
                    rowID: this.editItem.id,
                    oldStockFamilyID: this.editItem.stockFamilyId,
                    newStockFamilyID: this.familyAggregationSelected.value,
                    oldProductID: this.editItem.idProdottoSim,
                    newProductID: this.productAggregationSelected.value,
                    target: this.editItem.target
                });
            }
            this.updateTargetDialogVisible = false;
        },
        automaticCalculateSave(){
            this.autoSaveWarnings= [];
            let body = {
                headerId: this.autoHeaderId,
                updateList: this.autoUpdateList
            };
            this.$store.dispatch("generic/setLoading", true);
            Service.updateStocchinoPlanAuto(body, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.load();
                    if(response.warnings && response.warnings.length > 0){
                        this.$toast.add({detail: this.$t('StocchinoPlan.saveHasWarnings'), life:3000, severity:'warn'});
                    }
                    this.autoSaveWarnings = response.warnings;
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        inventoryCalculateSave(){
            let body = {
                headerId: this.inventoryHeaderId,
                updateList: this.inventoryUpdateList
            };
            this.$store.dispatch("generic/setLoading", true);
            Service.updateStocchinoPlanInventory(body, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.load();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        minMaxWsSave(){
            
            let body = {
                headerId: this.minMaxWsHeaderId,
                updateList: this.minMaxWsUpdateList
            };
            this.$store.dispatch("generic/setLoading", true);
            Service.updateStocchinoPlanMinMaxWS(body, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.load();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        showEditFamily(data){
            this.editItem = data;
            this.productAggregationSelected = null;
            this.familyAggregationSelected = null;
            this.productAggregationComboProductLevelValue = null;
            this.productAggregationComboFamilyLevelValue = null;
            this.updateFamilyDialogVisible = true;
        },
        setFamily(){
            let found = this.autoUpdateList.find(item => item.rowID == this.editItem.id);
            if(found){
                found.oldStockFamilyID = this.editItem.stockFamilyId;
                    found.newStockFamilyID = this.familyAggregationSelected.value;
            }else{
                this.autoUpdateList.push({
                    rowID: this.editItem.id,
                    oldStockFamilyID: this.editItem.stockFamilyId,
                    newStockFamilyID: this.familyAggregationSelected.value,
                    oldProductID: null,
                    newProductID: null
                });
            }
            this.updateFamilyDialogVisible = false;
        },
        setCompany(){
            let found = this.autoUpdateList.find(item => item.rowID == this.editItem.id);
            if(found){
                found.oldOwnerCompanyId = this.editItem.ownerCompanyId;
                found.newOwnerCompanyId = this.companySelected.value;
            }else{
                this.autoUpdateList.push({
                    rowID: this.editItem.id,
                    oldOwnerCompanyId: this.editItem.ownerCompanyId,
                    newOwnerCompanyId: this.companySelected.value
                });
            }
            
            this.editItem.ownerCompanyId = this.companySelected.value;
            this.editItem.ownerCompanyDescription = this.companySelected.label;
            this.updateOwnerCompanyDialogVisible = false;
        },
        showOutOfServiceChanged(data){
            this.$confirm.require({
                message: this.$t('StocchinoPlan.messageOutOfServiceChangedAuto'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    this.setOutOfService(data)
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        showAutoWarnings(){
            this.autoSaveWarningsDialogVisible = true;
        },
        showSummaryToggle(){
            this.inventoryShowSummary = !this.inventoryShowSummary
        },
        onCellEditCompleteInventory(event){
            let { data, newValue, field } = event;
            data[field] = newValue ?? 0;
            let found = this.inventoryUpdateList.find(item => item.rowId == data.id);
            if(found){
                found[field] = data[field];
            }else{
                data.rowId = data.id;
                this.inventoryUpdateList.push(data);
            }
        },
        onCellEditCompleteMinMaxWs(event){
            let { data, newValue, field } = event;
            data[field] = newValue ?? 0;
            let found = this.minMaxWsUpdateList.find(item => item.id == data.id);
            if(found){
                found = data
            }else{
                this.minMaxWsUpdateList.push(data);
            }
        },
        loadInventoryHoldUp(){
            let body = {
                dataStocchino: Utils.formatDateForAPI(this.filters.dataStocchino)
            }
            Service.getStocchinoPlanHoldUpQuantities(body, response => {
                this.inventoryLoading = false;
                if(response.success){
                    let holdUpQuantities = response.data;
                    for(let i=0; i<holdUpQuantities.length; i++){
                        let found = this.inventoryItems.find(item => item.stockFamilyId == holdUpQuantities[i].stockFamilyId && (!item.ownerCompanyId || item.ownerCompanyId == holdUpQuantities[i].productOwnerId));
                        if(found){
                            let updateFound = this.inventoryUpdateList.find(item => item.rowId == found.id);
                            if(updateFound){
                                updateFound.holdUpQty = holdUpQuantities[i].quantity;
                            }else{
                                found.rowId = found.id;
                                found.holdUpQty = holdUpQuantities[i].quantity;
                                this.inventoryUpdateList.push(found);
                            }
                            found.holdUpQty = holdUpQuantities[i].quantity;
                        }           
                    }
                }
            });
        },
        exportReport(){
            this.$store.dispatch("generic/setLoading", true);

            let body = {
                dataStocchino: Utils.formatDateForAPI(this.filters.dataStocchino)
            }
            Service.exportStocchinoPlan(body, response => {
                this.$store.dispatch("generic/setLoading", false);
                
                if(response.success){
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    let fileName = `Stock_${body.dataStocchino}.xlsx`
                    fileLink.setAttribute('download', fileName);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                } else{
                    this.$toast.add({ detail: response.message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        autoTotal(name, stockFamilyId){
            let filtered = this.autoItems.filter(item => item.stockFamilyId == stockFamilyId );
            let total = filtered.reduce((sum, item) => sum + item[name], 0);
            if(name != 'density'){
                return total;
            }
            return Utils.formatDecimal(total/filtered.length, 4);
        },
        storageTotal(name, stockFamilyParentDescription, site){
            let filtered = this.familyStorageItems.filter(item => item.stockFamilyParentDescription == stockFamilyParentDescription && item.site == site);
            let total = filtered.reduce((sum, item) => sum + item[name], 0);
            if(name != 'density'){
                return total;
            }
            return Utils.formatDecimal(total/filtered.length, 4);
        },
        inventoryTotal(name){
            if(this.inventoryItems.length > 0){
                let total = this.inventoryItems.reduce((sum, item) => sum + item[name], 0);
                if(name != 'density'){
                    return Utils.formatDecimal(total, 2);
                }
                return Utils.formatDecimal(total/this.inventoryItems.length, 4);
            }
            return 0;
        },
        onTabChange(e){
            if(e.index != this.lastActiveTab){

                switch(this.lastActiveTab){
                    case 0:
                        if(this.autoUpdateList.length > 0){
                            this.$confirm.require({
                                message: this.$t('StocchinoPlan.changeTabMessage'),
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: this.$t('yes'),
                                rejectLabel: this.$t('no'),
                                accept: () => {
                                    this.loadAuto();
                                    this.lastActiveTab = e.index;
                                },
                                reject: () => {
                                    this.changeTab(this.lastActiveTab);
                                    //callback to execute when user rejects the action
                                    this.$confirm.close();
                                }
                            });
                        }else{
                            this.lastActiveTab = e.index;
                        }
                    break;
                    case 1:
                        this.lastActiveTab = e.index;
                    break;
                    case 2:
                        if(this.inventoryUpdateList.length > 0){
                            this.$confirm.require({
                                message: this.$t('StocchinoPlan.changeTabMessage'),
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: this.$t('yes'),
                                rejectLabel: this.$t('no'),
                                accept: () => {
                                    this.loadInventory();
                                    this.lastActiveTab = e.index;
                                },
                                reject: () => {
                                    this.changeTab(this.lastActiveTab);
                                    //callback to execute when user rejects the action
                                    this.$confirm.close();
                                }
                            });
                        }else{
                            this.lastActiveTab = e.index;
                        }
                    break;
                    case 3:
                        if(this.minMaxWsUpdateList.length > 0){
                            this.$confirm.require({
                                message: this.$t('StocchinoPlan.changeTabMessage'),
                                icon: 'pi pi-exclamation-triangle',
                                acceptLabel: this.$t('yes'),
                                rejectLabel: this.$t('no'),
                                accept: () => {
                                    this.loadMinMaxWs();
                                    this.lastActiveTab = e.index;
                                },
                                reject: () => {
                                    this.changeTab(this.lastActiveTab);
                                    //callback to execute when user rejects the action
                                    this.$confirm.close();
                                }
                            });
                        }else{
                            this.lastActiveTab = e.index;
                        }
                    break;
                }

                
            }
        },
        changeTab(index){
            this.activeTab = index;

        },
        exportInDailyProfiles(item){
            this.exportMinMaxWS = {
                startDate: null,
                minWS: item.minWS,
                maxWS: item.maxWS,
                stockFamilyId: item.stockFamilyId,
                ownerCompanyId: item.ownerCompanyId
            };
            this.exportMinMaxWSVisible = true;
        },
        performExportMinMaxWS(){
            let body = {...this.exportMinMaxWS};
            body.startDate = Utils.formatDateForAPI(this.exportMinMaxWS.startDate)
            this.$store.dispatch("generic/setLoading", true);
            Service.exportMinMaxWsDp(body, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$toast.add({ detail: this.$t('DailyProfiles.exportMinMaxWSSuccess'), life: 3000, severity: 'success' });
                } else{
                    this.$toast.add({ detail: response.message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
        },
        getTankComposition(data){
            this.tankContent = {};
            let body = {
                dataStocchino: Utils.formatDateForAPI(this.filters.dataStocchino),
                tankCode: data.tank
            };
            this.$store.dispatch("generic/setLoading", true);
            Service.getStocchinoPlanTankComposition(body, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){

                    this.tankCompositionTitle = `${this.$t('StocchinoPlan.tankCompositionTitle')} ${body.tankCode}`

                    let data = response.data;
                    let tankContent = {
                        labels: [],
                        datasets: [
                            {
                                data: [],
                                backgroundColor: [],
                                hoverBackgroundColor: []
                            }
                        ]
                    };

                    if(data.length > 0){
                        for(let i=0; i<data.length; i++){
                            let item = data[i];
                            tankContent.labels.push(`${item.registryProduct} - ${item.quantityPercentage} %`);
                            tankContent.datasets[0].data.push(item.quantityPercentage);

                            let colorIndex = i > this.backgroundColor.length - 1 ? (i % this.backgroundColor.length -1) : i;

                            tankContent.datasets[0].backgroundColor.push(this.backgroundColor[colorIndex]);
                            tankContent.datasets[0].hoverBackgroundColor.push(this.hoverBackgroundColor[colorIndex]);

                        }

                        this.tankContent = tankContent;

                        this.tankContentVisible = true;
                    } else {
                        this.$toast.add({ detail: response.message || this.$t('StocchinoPlan.tankCompositionNotAvailable'), life: 3000, severity: 'warning' });
                    }
                } else{
                    this.$toast.add({ detail: response.message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            });
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        refDate(){
            return this.filters.dataStocchino ?  Utils.formatDateForAPI(this.filters.dataStocchino) : null
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        }
    }
}

//
</script>
<template>
    <Dialog v-model:visible="tankContentVisible" modal :style="{ width: '80vh' }">
        <template #header>
           <h3 style="margin: 0 auto;">{{ tankCompositionTitle }}</h3>
        </template>
        <Chart type="pie" :data="tankContent" :options="tankContentOptions"/>
    </Dialog>
    <Dialog v-model:visible="autoSaveWarningsDialogVisible" modal>
        <ul>
            <li v-for="(item, index) in autoSaveWarnings" :key="index" class="padding:10px">{{ item }}</li>
        </ul>
    </Dialog>
    <Dialog v-model:visible="updateTargetDialogVisible" :style="{ 'width': '350px' }" modal>
        <div class="grid">
            <div class="col-12">
                <label for="week">{{$t('StocchinoPlan.product')}}</label>
                <GenericCustomMasterDataAutocompleteV2
                    class="w-full"
                    :name="'productAggregationComboProductLevel' + refDate"
                    v-model="productAggregationComboProductLevelValue"
                    :changeFn="onProductSelected"
                    :api="'stocchino-plan-registry/product-aggregation-combo-productlevel?dataRif=' + refDate"/>
            </div>
            <div class="col-12">
                <label for="week">{{$t('StocchinoPlan.family')}}</label>
                <GenericCustomMasterDataAutocompleteV2
                    ref="productAggregationComboFamilyLevel"
                    class="w-full"
                    :name="'productAggregationComboFamilyLevel' + refDate"
                    v-model="productAggregationComboFamilyLevelValue"
                    :changeFn="onFamilySelected"
                    :api="'stocchino-plan-registry/product-aggregation-combo-familylevel?dataRif=' + refDate"/>
            </div>
            <div class="col-12">
                <Button class="w-full" icon="fa-solid fa-check" @click="setProductAndFamily" :disabled="!productAggregationSelected || !familyAggregationSelected"/>
            </div>
        </div>
    </Dialog>
    <Dialog v-model:visible="updateFamilyDialogVisible" :style="{ 'width': '350px' }" modal>
        <div class="grid">
            <div class="col-12">
                <label for="week">{{$t('StocchinoPlan.family')}}</label>
                <GenericCustomMasterDataAutocompleteV2
                    ref="productAggregationComboFamilyLevelAll"
                    class="w-full"
                    :name="'productAggregationComboFamilyLevelAll' + refDate"
                    v-model="ownerCompanyLevelValue"
                    :api="'stocchino-plan-registry/product-aggregation-combo-familylevel?dataRif=' + refDate"/>
            </div>
            <div class="col-12">
                <Button class="w-full" icon="fa-solid fa-check" @click="setFamily" :disabled="!familyAggregationSelected"/>
            </div>
        </div>
    </Dialog>
    <Dialog v-model:visible="updateOwnerCompanyDialogVisible" :style="{ 'width': '350px' }" modal>
        <div class="grid">
            <div class="col-12">
                <label for="week">{{$t('StocchinoPlan.ownerCompanyDescription')}}</label>
                <GenericCustomMasterDataAutocompleteV2
                    ref="ownerCompanyDescriptionStocchinoPlan"
                    class="w-full"
                    :name="'ownerCompanyDescriptionStocchinoPlan'"
                    v-model="ownerCompanyLevelValue"
                    :changeFn="onCompanySelected"
                    api="masterdata/company-combo?getOnlyValid=true&getOnlyStocchinoPlanEnabled=true" />
            </div>
            <div class="col-12">
                <Button class="w-full" icon="fa-solid fa-check" @click="setCompany" :disabled="!ownerCompanyLevelValue"/>
            </div>
        </div>
    </Dialog>
    <div class="grid">
        <div class="col-12 m-2" style="height: calc(75vh)">
            <TabView v-model:activeIndex="activeTab" @tab-change="onTabChange">
                <TabPanel :header="$t('StocchinoPlan.automatic_title')">
                    <Toolbar>
                        <template #start>
                            <div class="field m-3">
                                <label for="dataStocchino">{{$t('StocchinoPlan.dataStocchino')}}</label>
                                <Calendar
                                    :class="{'p-inputtext-sm w-full': true}"
                                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                    :dateFormat="constants.DATE_FORMAT_POINT"
                                    :showTime="false"
                                    v-model="filters.dataStocchino"
                                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />

                            </div>
                            <div class="field">
                                <div class="pt-4">
                                    <ResponsiveButton :label="$t('btn.load')" icon="pi pi-sync" class="mx-1 p-button-sm mt-4" @click="load" />
                                    <SplitButton :label="$t('btn.calculate')" :model="automaticCalculateSplitButtonItems" class="mt-4 p-button-sm" icon="fa-solid fa-gears" :disabled="uiPermissions('StocchinoPlan.calculateSplitButton').isHidden"/>
                                    <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="mx-1 p-button-sm p-button-danger mt-4" @click="automaticCalculateSave" :disabled="uiPermissions('StocchinoPlan.saveButton').isHidden || !autoUpdateList || autoUpdateList.length == 0"/>
                                </div>
                            </div>
                        </template>
                        <template #end>
                            <ResponsiveButton :label="$t('btn.warnings')" icon="fa-solid fa-triangle-exclamation" class="mx-1 p-button-sm mt-4" @click="showAutoWarnings" v-if="autoSaveWarnings && autoSaveWarnings.length > 0"/>
                            <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file-excel" class="mx-1 p-button-sm mt-4" @click="exportReport" />
                        </template>
                    </Toolbar>
                    <div class="card">
                        <DataTable :value="autoItems" :loading="autoLoading" scrollable scrollHeight="70vh" tableStyle="min-width: 50rem" rowGroupMode="subheader" groupRowsBy="stockFamilyDescription" showGridlines>
                            <Column field="stockFamilyDescription" header="stockFamilyDescription" /> 
                            <Column class="button-column" :exportable="false">
                                <template #body="slotProps">
                                    <Button icon="fa-solid fa-triangle-exclamation" class="p-button-sm p-button-rounded p-button-outlined p-button-danger mr-1 mb-1" @click="showEditFamily(slotProps.data)" size="small"
                                        v-if="(slotProps.data.stockFamilyIdChanged && !slotProps.data.stockFamilySetByUser)" />
                                    <Button icon="fa-solid fa-exclamation" class="p-button-sm p-button-rounded p-button-outlined p-button-danger mr-1 mb-1" @click="showOutOfServiceChanged(slotProps.data)" size="small"
                                        v-if="(slotProps.data.isStatoFuoriServizioChanged && !slotProps.data.isFuoriServizioSetByUser)" />
                                    <Button icon="fa-solid fa-chart-pie" class="p-button-sm p-button-rounded p-button-outlined p-button-danger mr-1 mb-1" @click="getTankComposition(slotProps.data)" size="small" />
                                </template>
                            </Column>
                            <Column field="tank" :header="$t('StocchinoPlan.tank')" style="width: 150px;"></Column>
                            <Column field="isFuoriServizio" :header="$t('StocchinoPlan.isFuoriServizio')" style="width: 150px;">
                                <template #body="{data, field}">
                                    <i :class="{'out-of-service-true fa-solid fa-circle-check' : !data[field], 'out-of-service-false fa-solid fa-circle-xmark': data[field]}" @click="setOutOfService(data)"/>
                                </template>
                            </Column>
                            <Column field="site" :header="$t('StocchinoPlan.site')" style="width: 150px;"></Column>
                            <Column field="target" :header="$t('StocchinoPlan.target')" style="width: 150px;">
                                <template #body="{data, field}">
                                    <p class="target-field" :class="{'target-field-out-of-service' : data[field] == 'Out Of Service'}" @click="showEditTarget(data)">{{ data[field] }}</p>
                                </template>
                            </Column>
                            <Column field="ownerCompanyDescription" :header="$t('StocchinoPlan.ownerCompanyDescription')" style="width: 150px;">
                                <template #body="{data, field}">
                                    <p class="target-field" :class="{'target-field-out-of-service' : !data.ownerCompanyId}" @click="showEditCompany(data)">{{ !data.ownerCompanyId ? $t('StocchinoPlan.ownerCompanyDescriptionNotSpecified') : data[field] }}</p>
                                </template>
                            </Column>
                            <Column field="isSemiFinished" :header="$t('StocchinoPlan.isSemiFinished')" style="width: 150px;">
                                <template #body="{data, field}">
                                    <i :class="{'true-icon fa-solid fa-check': data[field], 'false-icon fa-solid fa-xmark': !data[field]}"></i>
                                </template>
                            </Column>
                            <Column field="density" :header="$t('StocchinoPlan.density')" style="width: 150px;"></Column>
                            <Column field="productLevel" :header="$t('StocchinoPlan.productLevel')" style="width: 150px;"></Column>
                            <Column field="waterLevel" :header="$t('StocchinoPlan.waterLevel')" style="width: 150px;"></Column>
                            <Column field="volH2O" :header="$t('StocchinoPlan.volH2O')" style="width: 150px;"></Column>
                            <Column field="volExtractable" :header="$t('StocchinoPlan.volExtractable')" style="width: 150px;"></Column>
                            <Column field="volEmpty" :header="$t('StocchinoPlan.volEmpty')" style="width: 150px;"></Column>
                            <Column field="weightExtractable" :header="$t('StocchinoPlan.weightExtractable')" style="width: 150px;"></Column>
                            <Column field="weightEmpty" :header="$t('StocchinoPlan.weightEmpty')" style="width: 150px;"></Column>
                            <Column field="volTotal" :header="$t('StocchinoPlan.volTotal')" style="width: 150px;"></Column>
                            <Column field="weightTotal" :header="$t('StocchinoPlan.weightTotal')" style="width: 150px;"></Column>
                            <Column field="weightUnextractable" :header="$t('StocchinoPlan.unextractableQty')" style="width: 150px;"></Column>
                            <template #groupheader="slotProps">
                                <div class="flex align-items-center gap-2">
                                    <span>{{ convertFamilyDescription(slotProps.data) }}</span>
                                </div>
                            </template>
                            <template #groupfooter="slotProps">
                                <td colspan="1" style="padding: 1rem"></td>
                                <td colspan="1" style="padding: 1rem"></td>
                                <td colspan="1" style="padding: 1rem"></td>
                                <td colspan="1" style="padding: 1rem"></td>
                                <td colspan="1" style="padding: 1rem"></td>
                                <td colspan="1" style="padding: 1rem"></td>
                                <td colspan="1" style="padding: 1rem"></td>

                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{autoTotal('density', slotProps.data.stockFamilyId)}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{autoTotal('productLevel', slotProps.data.stockFamilyId)}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{autoTotal('waterLevel', slotProps.data.stockFamilyId)}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{autoTotal('volH2O', slotProps.data.stockFamilyId)}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{autoTotal('volExtractable', slotProps.data.stockFamilyId)}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{autoTotal('volEmpty', slotProps.data.stockFamilyId)}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{autoTotal('weightExtractable', slotProps.data.stockFamilyId)}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{autoTotal('weightEmpty', slotProps.data.stockFamilyId)}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{autoTotal('volTotal', slotProps.data.stockFamilyId)}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{autoTotal('weightTotal', slotProps.data.stockFamilyId)}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{autoTotal('weightUnextractable', slotProps.data.stockFamilyId)}}</td>
                                <!-- <td colspan="1" style="padding: 1rem">{{ slotProps.data.stockFamilyDescription }}</td> -->
                            </template>
                        </DataTable>
                    </div>
                </TabPanel>
                <TabPanel :header="$t('StocchinoPlan.productFamilyStorage_title')">
                    <Toolbar>
                        <template #start>
                            <div class="field m-3">
                                <label for="dataStocchino">{{$t('StocchinoPlan.dataStocchino')}}</label>
                                <Calendar
                                    :class="{'p-inputtext-sm w-full': true}"
                                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                    :dateFormat="constants.DATE_FORMAT_POINT"
                                    :showTime="false"
                                    v-model="filters.dataStocchino"
                                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />

                            </div>
                            <div class="field">
                                <div class="pt-4">
                                    <ResponsiveButton :label="$t('btn.load')" icon="pi pi-sync" class="mx-1 p-button-sm mt-4" @click="load" />
                                </div>
                            </div>
                        </template>
                        <template #end>
                            <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file-excel" class="mx-1 p-button-sm mt-4" @click="exportReport" />
                        </template>
                    </Toolbar>
                    
                    <div class="card">
                        <DataTable :value="familyStorageItems" :loading="familyStorageLoading" scrollable scrollHeight="70vh" tableStyle="min-width: 50rem" rowGroupMode="subheader" :groupRowsBy="familyStorageGroupBy" showGridlines>
                            <!-- <Column field="stockFamilyParentDescription" header="stockFamilyParentDescription" />  -->
                            <Column field="stockFamilyDescription" :header="$t('StocchinoPlan.stockFamilyDescription')" style="width: 150px;"></Column>
                            <Column field="site" :header="$t('StocchinoPlan.site')" style="width: 150px;"></Column>
                            <Column field="ownerCompanyDescription" :header="$t('StocchinoPlan.ownerCompanyDescription')" style="width: 150px;"></Column>
                            <Column field="volTotal" :header="$t('StocchinoPlan.volTotal')" style="width: 150px;"></Column>
                            <Column field="weightTotal" :header="$t('StocchinoPlan.weightTotal')" style="width: 150px;"></Column>
                            <Column field="volExtractable" :header="$t('StocchinoPlan.volExtractable')" style="width: 150px;"></Column>
                            <Column field="volEmpty" :header="$t('StocchinoPlan.volEmpty')" style="width: 150px;"></Column>
                            <Column field="weightExtractable" :header="$t('StocchinoPlan.weightExtractable')" style="width: 150px;"></Column>
                            <Column field="weightEmpty" :header="$t('StocchinoPlan.weightEmpty')" style="width: 150px;"></Column>
                            <Column field="weightUnextractable" :header="$t('StocchinoPlan.unextractableQty')" style="width: 150px;"></Column>
                            <template #groupheader="slotProps">
                                <div class="flex align-items-center gap-2">
                                    <span>{{ convertFamilyDescriptionForStorage(slotProps.data) }}</span>
                                </div>
                            </template>
                            <template #groupfooter="slotProps">
                                <td colspan="1" style="padding: 1rem"></td>
                                <td colspan="1" style="padding: 1rem"></td>
                                <td colspan="1" style="padding: 1rem"></td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{storageTotal('volTotal', slotProps.data.stockFamilyParentDescription, slotProps.data.site)}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{storageTotal('weightTotal', slotProps.data.stockFamilyParentDescription, slotProps.data.site)}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{storageTotal('volExtractable', slotProps.data.stockFamilyParentDescription, slotProps.data.site)}}</td>
                                
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{storageTotal('volEmpty', slotProps.data.stockFamilyParentDescription, slotProps.data.site)}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{storageTotal('weightExtractable', slotProps.data.stockFamilyParentDescription, slotProps.data.site)}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{storageTotal('weightEmpty', slotProps.data.stockFamilyParentDescription, slotProps.data.site)}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{storageTotal('weightUnextractable', slotProps.data.stockFamilyParentDescription, slotProps.data.site)}}</td>
                                <!-- <td colspan="1" style="padding: 1rem">{{ slotProps.data.stockFamilyDescription }}</td> -->
                            </template>
                        </DataTable>
                    </div>
                </TabPanel>
                <TabPanel :header="$t('StocchinoPlan.inventory_title')">
                    <Toolbar>
                        <template #start>
                            <div class="field m-3">
                                <label for="dataStocchino">{{$t('StocchinoPlan.dataStocchino')}}</label>
                                <Calendar
                                    :class="{'p-inputtext-sm w-full': true}"
                                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                    :dateFormat="constants.DATE_FORMAT_POINT"
                                    :showTime="false"
                                    v-model="filters.dataStocchino"
                                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />

                            </div>
                            <div class="field">
                                <div class="pt-4">
                                    <ResponsiveButton :label="$t('btn.load')" icon="pi pi-sync" class="mx-1 p-button-sm mt-4" @click="load" />
                                    <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="mx-1 p-button-sm p-button-danger mt-4" @click="inventoryCalculateSave" :disabled="uiPermissions('StocchinoPlan.saveButton').isHidden || !inventoryUpdateList || inventoryUpdateList.length == 0"/>
                                    <ResponsiveButton :label="$t('StocchinoPlan.inventoryHoldUpLoadBtn')" icon="pi pi-download" class="mx-1 p-button-sm mt-4" @click="loadInventoryHoldUp" :disabled="uiPermissions('StocchinoPlan.saveButton').isHidden"/>
                                    <ResponsiveButton :label="inventoryShowSummary ? $t('StocchinoPlan.inventoryViewBtn') : $t('StocchinoPlan.summaryViewBtn')" icon="pi pi-eye" class="mx-1 p-button-sm mt-4" @click="showSummaryToggle" />
                                </div>
                            </div>
                        </template>
                        <template #end>
                            <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file-excel" class="mx-1 p-button-sm mt-4" @click="exportReport" />
                        </template>
                    </Toolbar>
                    
                    <div class="card">
                        <DataTable :value="inventoryItems" :loading="inventoryLoading" scrollable scrollHeight="70vh" responsiveLayout="'scroll'" tableStyle="min-width: 50rem" 
                        editMode="cell" @cell-edit-complete="onCellEditCompleteInventory" showGridlines rowGroupMode="subheader" :groupRowsBy="inventoryGroupBy">
                            <ColumnGroup type="header">
                                <Row>
                                    
                                    <Column :header="$t('StocchinoPlan.stockFamilyDescription') +'-'+$t('StocchinoPlan.ownerCompanyDescription') " :rowspan="2" frozen/>
                                    <Column :header="$t('StocchinoPlan.inventory')" :colspan="3"/>
                                    <Column :header="$t('StocchinoPlan.availableVolume')" :colspan="3"/>
                                    <Column :header="$t('StocchinoPlan.inventoryExtractable')" :colspan="3" v-if="inventoryShowSummary" />
                                    <Column :header="$t('StocchinoPlan.inventoryUnextractable')" :colspan="3" v-if="inventoryShowSummary" />
                                    <Column :header="$t('StocchinoPlan.holdUpQty')" :rowspan="2" />
                                    <Column :header="$t('StocchinoPlan.inventoryHoldUpQty')" :rowspan="2" />
                                    <Column :header="$t('StocchinoPlan.floatingStorageQty')" :rowspan="2" v-if="inventoryShowSummary" />
                                    <Column :header="$t('StocchinoPlan.inventoryLukoilTotalQty')" :rowspan="2" v-if="inventoryShowSummary" />
                                    
                                    <Column :header="$t('StocchinoPlan.target')" :colspan="inventoryShowSummary ? 4: 3"/>
                                    <Column :header="$t('StocchinoPlan.maxVolumeOfTanksQty')" :rowspan="2" v-if="inventoryShowSummary"/>
                                    <Column :header="$t('StocchinoPlan.delta')" :colspan="inventoryShowSummary ? 4 : 2"/>
                                </Row>
                                <Row>
                                    <!-- <Column :header="$t('StocchinoPlan.stockFamilyDescription')" field="stockFamilyDescription" frozen/>
                                    <Column :header="$t('StocchinoPlan.ownerCompanyDescription')" field="ownerCompanyDescription" frozen/> -->
                                    <Column :header="$t('StocchinoPlan.inventorySouthQty')" field="inventorySouthQty"/>
                                    <Column :header="$t('StocchinoPlan.inventoryNorthQty')" field="inventoryNorthQty"/>
                                    <Column :header="$t('StocchinoPlan.inventoryTotalQty')" field="inventoryTotalQty"/>
                                    <Column :header="$t('StocchinoPlan.availableVolumeOfTanksSouthQty')" field="availableVolumeOfTanksSouthQty"/>
                                    <Column :header="$t('StocchinoPlan.availableVolumeOfTanksNorthQty')" field="availableVolumeOfTanksNorthQty"/>
                                    <Column :header="$t('StocchinoPlan.availableVolumeOfTanksTotalQty')" field="availableVolumeOfTanksTotalQty"/>
                                    <Column :header="$t('StocchinoPlan.inventoryExtractableSouthQty')" field="inventoryExtractableSouthQty" v-if="inventoryShowSummary"/>
                                    <Column :header="$t('StocchinoPlan.inventoryExtractableNorthQty')" field="inventoryExtractableNorthQty" v-if="inventoryShowSummary"/>
                                    <Column :header="$t('StocchinoPlan.inventoryExtractableTotalQty')" field="inventoryExtractableTotalQty" v-if="inventoryShowSummary"/>
                                    <Column :header="$t('StocchinoPlan.inventoryExtractableSouthQty')" field="inventoryUnextractableSouthQty" v-if="inventoryShowSummary"/>
                                    <Column :header="$t('StocchinoPlan.inventoryExtractableNorthQty')" field="inventoryUnextractableNorthQty" v-if="inventoryShowSummary"/>
                                    <Column :header="$t('StocchinoPlan.inventoryExtractableTotalQty')" field="inventoryUnextractableTotalQty" v-if="inventoryShowSummary"/>

                                    <Column :header="$t('StocchinoPlan.minWSQty')" field="minWSQty"/>
                                    <Column :header="$t('StocchinoPlan.maxWSQty')" field="maxWSQty"/>
                                    <Column :header="$t('StocchinoPlan.isabTargetQty')" field="isabTargetQty"/>
                                    <Column :header="$t('StocchinoPlan.lukoilTargetQty')" field="lukoilTargetQty" v-if="inventoryShowSummary"/>
                                    <Column :header="$t('StocchinoPlan.deltaInvMinWSQty')" field="deltaInvMinWSQty" v-if="!inventoryShowSummary"/>
                                    <Column :header="$t('StocchinoPlan.deltaMinWSInvQty')" field="deltaMinWSInvQty" v-if="inventoryShowSummary"/>
                                    <Column :header="$t('StocchinoPlan.deltaMaxWSInvQty')" field="deltaMaxWSInvQty" v-if="inventoryShowSummary"/>
                                    <Column :header="$t('StocchinoPlan.deltaIsabTargetInvQty')" field="deltaIsabTargetInvQty"/>
                                    <Column :header="$t('StocchinoPlan.deltaLukoilTargetLukoilInvQty')" field="deltaLukoilTargetLukoilInvQty" v-if="inventoryShowSummary"/>
                                </Row>
                            </ColumnGroup>
                            <!-- <Column field="stockFamilyDescription" :style="{width: '150px'}" frozen/>
                            <Column field="ownerCompanyDescription" :style="{width: '150px'}" frozen /> -->
                            <Column field="ownerCompanyDescription" :header="$t('StocchinoPlan.stockFamilyDescription') + '-' + $t('StocchinoPlan.ownerCompanyDescription')" style="width: 150px;" frozen>
                                <template #body="{ data }">
                                    {{ data.stockFamilyDescription }} - {{ data.ownerCompanyDescription }}
                                </template>
                            </Column>
                            <Column field="inventorySouthQty" :style="{width: '150px'}">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="inventoryNorthQty" :style="{width: '150px'}" >
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="inventoryTotalQty" :style="{width: '150px'}">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="availableVolumeOfTanksSouthQty" :style="{width: '150px'}">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="availableVolumeOfTanksNorthQty" :style="{width: '150px'}">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="availableVolumeOfTanksTotalQty" :style="{width: '150px'}">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="inventoryExtractableSouthQty" :style="{width: '150px'}" v-if="inventoryShowSummary">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="inventoryExtractableNorthQty" :style="{width: '150px'}" v-if="inventoryShowSummary">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="inventoryExtractableTotalQty" :style="{width: '150px'}" v-if="inventoryShowSummary">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="inventoryUnextractableSouthQty" :style="{width: '150px'}" v-if="inventoryShowSummary">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="inventoryUnextractableNorthQty" :style="{width: '150px'}" v-if="inventoryShowSummary">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="inventoryUnextractableTotalQty" :style="{width: '150px'}" v-if="inventoryShowSummary">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="holdUpQty" :style="{width: '150px'}">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="inventoryHoldUpQty" :style="{width: '150px'}">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="floatingStorageQty" :style="{width: '150px', 'backgroundColor': 'green', 'color': 'white'}" v-if="inventoryShowSummary">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                                <template #editor="{ data, field }">
                                    <InputNumber v-model="data[field]" autofocus v-tooltip.top="data[field]" :minFractionDigits="2" :maxFractionDigits="2" highlightOnFocus/>
                                </template>
                            </Column><!--EDITABILE-->
                            <Column field="inventoryLukoilTotalQty" :style="{width: '150px'}" v-if="inventoryShowSummary">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                           
                            <Column field="minWSQty" :style="{width: '150px'}">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="maxWSQty" :style="{width: '150px'}">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="isabTargetQty" :style="{width: '150px', 'backgroundColor': 'green', 'color': 'white'}">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                                <template #editor="{ data, field }">
                                    <InputNumber v-model="data[field]" autofocus v-tooltip.top="data[field]" :minFractionDigits="2" :maxFractionDigits="2" highlightOnFocus />
                                </template>
                            </Column>
                            <Column field="lukoilTargetQty" :style="{width: '150px', 'backgroundColor': 'green', 'color': 'white'}" v-if="inventoryShowSummary">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                                <template #editor="{ data, field }">
                                    <InputNumber v-model="data[field]" autofocus v-tooltip.top="data[field]" :minFractionDigits="2" :maxFractionDigits="2" highlightOnFocus />
                                </template>
                            </Column>
                            <Column field="maxVolumeOfTanksQty" :style="{width: '150px'}" v-if="inventoryShowSummary">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="deltaInvMinWSQty" :style="{width: '150px'}"  v-if="!inventoryShowSummary">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="deltaMinWSInvQty" :style="{width: '150px'}" v-if="inventoryShowSummary">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="deltaMaxWSInvQty" :style="{width: '150px'}"  v-if="inventoryShowSummary">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="deltaIsabTargetInvQty" :style="{width: '150px'}">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>
                            <Column field="deltaLukoilTargetLukoilInvQty" :style="{width: '150px'}"  v-if="inventoryShowSummary">
                                <template #body="{ data, field }">
                                    <span>{{ utils.formatDecimal(data[field],2) }}</span>
                                </template>
                            </Column>

                            <template #groupfooter>
                                <!-- <td colspan="1" style="padding: 1rem"></td> -->
                                <td colspan="1" style="padding: 1rem"></td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{inventoryTotal('inventorySouthQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{inventoryTotal('inventoryNorthQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{inventoryTotal('inventoryTotalQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{inventoryTotal('availableVolumeOfTanksSouthQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{inventoryTotal('availableVolumeOfTanksNorthQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{inventoryTotal('availableVolumeOfTanksTotalQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold" v-if="inventoryShowSummary">{{inventoryTotal('inventoryExtractableSouthQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold" v-if="inventoryShowSummary">{{inventoryTotal('inventoryExtractableNorthQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold" v-if="inventoryShowSummary">{{inventoryTotal('inventoryExtractableTotalQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold" v-if="inventoryShowSummary">{{inventoryTotal('inventoryUnextractableSouthQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold" v-if="inventoryShowSummary">{{inventoryTotal('inventoryUnextractableNorthQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold" v-if="inventoryShowSummary">{{inventoryTotal('inventoryUnextractableTotalQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{inventoryTotal('holdUpQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{inventoryTotal('inventoryHoldUpQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold" v-if="inventoryShowSummary">{{inventoryTotal('floatingStorageQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold" v-if="inventoryShowSummary">{{inventoryTotal('inventoryLukoilTotalQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{inventoryTotal('minWSQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{inventoryTotal('maxWSQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{inventoryTotal('isabTargetQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold" v-if="inventoryShowSummary">{{inventoryTotal('lukoilTargetQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold" v-if="inventoryShowSummary">{{inventoryTotal('maxVolumeOfTanksQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold" v-if="!inventoryShowSummary">{{inventoryTotal('deltaInvMinWSQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold" v-if="inventoryShowSummary">{{inventoryTotal('deltaMinWSInvQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold" v-if="inventoryShowSummary">{{inventoryTotal('deltaMaxWSInvQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold">{{inventoryTotal('deltaIsabTargetInvQty')}}</td>
                                <td colspan="1" style="padding: 1rem; font-weight: bold" v-if="inventoryShowSummary">{{inventoryTotal('deltaLukoilTargetLukoilInvQty')}}</td>
                            </template>
                        </DataTable>
                    </div>
                </TabPanel>
                <TabPanel :header="$t('StocchinoPlan.minMaxWs_title')">
                    <Toolbar>
                        <template #start>
                            <div class="field m-3">
                                <label for="dataStocchino">{{$t('StocchinoPlan.dataStocchino')}}</label>
                                <Calendar
                                    :class="{'p-inputtext-sm w-full': true}"
                                    :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                    :dateFormat="constants.DATE_FORMAT_POINT"
                                    :showTime="false"
                                    v-model="filters.dataStocchino"
                                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />

                            </div>
                            <div class="field">
                                <div class="pt-4">
                                    <ResponsiveButton :label="$t('btn.load')" icon="pi pi-sync" class="mx-1 p-button-sm mt-4" @click="load" />
                                    <ResponsiveButton :label="$t('btn.save')" icon="pi pi-save" class="mx-1 p-button-sm p-button-danger mt-4" @click="minMaxWsSave" :disabled="uiPermissions('StocchinoPlan.saveButton').isHidden || !minMaxWsUpdateList || minMaxWsUpdateList.length == 0"/>
                                </div>
                            </div>
                        </template>
                        <template #end>
                            <ResponsiveButton :label="$t('btn.export')" icon="pi pi-file-excel" class="mx-1 p-button-sm mt-4" @click="exportReport" />
                        </template>
                    </Toolbar>
                    <div class="card">
                        <DataTable :value="minMaxWsItems" :loading="minMaxWsLoading" scrollable scrollHeight="70vh" :responsiveLayout="'scroll'" tableStyle="min-width: 50rem" showGridlines
                        editMode="cell" @cell-edit-complete="onCellEditCompleteMinMaxWs">
                            <!-- <Column field="stockFamilyDescription" :header="$t('StocchinoPlan.stockFamilyDescription')" style="width: 150px;" frozen></Column> -->
                            <Column field="ownerCompanyDescription" :header="$t('StocchinoPlan.stockFamilyDescription') + '-' + $t('StocchinoPlan.ownerCompanyDescription')" style="width: 150px;" frozen>
                                <template #body="{ data }">
                                    {{ data.stockFamilyDescription }} - {{ data.ownerCompanyDescription }}
                                </template>
                            </Column>
                            <Column field="volExtractable" :header="$t('StocchinoPlan.volExtractable')" style="width: 150px;"></Column>
                            <Column field="weightExtractable" :header="$t('StocchinoPlan.weightExtractable')" style="width: 150px;"></Column>
                            <Column field="volEmpty" :header="$t('StocchinoPlan.volEmpty')" style="width: 150px;"></Column>
                            <Column field="weightEmpty" :header="$t('StocchinoPlan.weightEmpty')" style="width: 150px;"></Column>
                            <Column field="volTotal" :header="$t('StocchinoPlan.volTotal')" style="width: 150px;"></Column>
                            <Column field="weightTotal" :header="$t('StocchinoPlan.weightTotal')" style="width: 150px;"></Column>

                            <Column field="density" :header="$t('StocchinoPlan.density')" style="width: 150px;"></Column>
                            <Column field="totalTankStorageQty" :header="$t('StocchinoPlan.totalTankStorageQty')" style="width: 150px;"></Column>
                            <Column field="unextractableQty" :header="$t('StocchinoPlan.unextractableQty')" style="width: 150px;"></Column>
                            <Column field="oneThirdSemifinishedProductQty" :header="$t('StocchinoPlan.oneThirdSemifinishedProductQty')" style="width: 150px;"></Column>
                            <Column field="safetyStockIN" :header="$t('StocchinoPlan.safetyStockIN')" :style="{width: '150px', 'backgroundColor': 'green', 'color': 'white'}">
                                <template #body="{ data, field }">
                                    <span  v-if="!data.isSemifinished">{{ data[field] }}</span>
                                </template>
                                <template #editor="{ data, field }">
                                    <InputNumber v-model="data[field]" autofocus v-tooltip.top="data[field]" :minFractionDigits="2" :maxFractionDigits="2" highlightOnFocus  v-if="!data.isSemifinished"/>
                                </template>
                            </Column>
                            <Column field="safetyTonsIN" :header="$t('StocchinoPlan.safetyTonsIN')" :style="{width: '150px', 'backgroundColor': 'green', 'color': 'white'}">
                                <template #body="{ data, field }">
                                    <span v-if="!data.isSemifinished">{{ data[field] }}</span>
                                </template>
                                <template #editor="{ data, field }">
                                    <InputNumber v-model="data[field]" autofocus v-tooltip.top="data[field]" :minFractionDigits="2" :maxFractionDigits="2" highlightOnFocus  v-if="!data.isSemifinished"/>
                                </template>
                            </Column>
                            <Column field="budgetTpIN" :header="$t('StocchinoPlan.budgetTpIN')" :style="{width: '150px', 'backgroundColor': 'green', 'color': 'white'}">
                                <template #body="{ data, field }">
                                    <span v-if="!data.isSemifinished">{{ data[field] }}</span>
                                </template>
                                <template #editor="{ data, field }">
                                    <InputNumber v-model="data[field]" autofocus v-tooltip.top="data[field]" :minFractionDigits="2" :maxFractionDigits="2" highlightOnFocus  v-if="!data.isSemifinished"/>
                                </template>
                            </Column>
                            <Column field="daysOfProductionIN" :header="$t('StocchinoPlan.daysOfProductionIN')" :style="{width: '150px', 'backgroundColor': 'green', 'color': 'white'}">
                                <template #body="{ data, field }">
                                    <span v-if="!data.isSemifinished">{{ data[field] }}</span>
                                </template>
                                <template #editor="{ data, field }">
                                    <InputNumber v-model="data[field]" autofocus v-tooltip.top="data[field]" :minFractionDigits="2" :maxFractionDigits="2" highlightOnFocus  v-if="!data.isSemifinished"/>
                                </template>
                            </Column>
                            <Column field="holdUpQtyIN" :header="$t('StocchinoPlan.holdUpQtyIN')" :style="{width: '150px', 'backgroundColor': 'green', 'color': 'white'}">
                                <template #body="{ data, field }">
                                    <span v-if="!data.isSemifinished">{{ data[field] }}</span>
                                </template>
                                <template #editor="{ data, field }">
                                    <InputNumber v-model="data[field]" autofocus v-tooltip.top="data[field]" :minFractionDigits="2" :maxFractionDigits="2" highlightOnFocus v-if="!data.isSemifinished"/>
                                </template>
                            </Column>
                            <Column field="minWS" :header="$t('StocchinoPlan.minWs')" style="width: 150px;">
                                <template #body="{ data }">
                                    <span v-if="!data.isSemifinished">{{ data.minWS }}</span>
                                </template>
                            </Column>
                            <Column field="maxWS" :header="$t('StocchinoPlan.maxWs')" style="width: 150px;">
                                <template #body="{ data }">
                                    <span v-if="!data.isSemifinished">{{ data.maxWS }}</span>
                                </template></Column>
                            <Column style="width: 150px;" header="Check">
                                <template #body="{ data }">
                                    <i class="fa-solid fa-check m-1" v-if="data.minWS < data.maxWS && !data.isSemifinished" />
                                    <i class="fa-solid fa-xmark m-1" style="color:red" v-if="data.minWS >= data.maxWS && !data.isSemifinished" />
                                    <i class="fa-solid fa-right-left m-1" @click="exportInDailyProfiles(data)" style="cursor:pointer" v-if="!data.isSemifinished" />
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                </TabPanel>
            </TabView>
        </div>
    </div>
    
    <Dialog v-model:visible="exportMinMaxWSVisible" modal>
        <p>{{$t('DailyProfiles.exportMinMaxWS') }}</p>
        <div class="grid">
            <div class="col-12 field">
                <label>{{ $t('DailyProfiles.startDate') }}</label>
                <Calendar 
                    class="w-full" 
                    v-model="exportMinMaxWS.startDate" 
                    dateFormat="dd/mm/yy" 
                    placeholder="dd/mm/yyyy"/>
            </div>
        </div>
        
        <div class="flex justify-content-end gap-2">
            <Button type="button" class="m-2" :label="$t('btn.cancel')" severity="secondary" @click="exportMinMaxWSVisible = false"></Button>
            <Button type="button" class="m-2" :label="$t('btn.save')" icon="pi pi-save" @click="performExportMinMaxWS"></Button>
        </div>
    
    </Dialog>
</template>

<style>

    .p-rowgroup-header{
        background-color: gray !important;
        color: white !important;
    }

    .true-icon{
        color: green;
        font-size: 1.5rem
    }

    .false-icon{
        color: red;
        font-size: 1.5rem
    }

    .out-of-service-true{
        font-size: 2rem;
        color: green;
        cursor: pointer;
    }

    .out-of-service-false{
        font-size: 2rem;
        color: red;
        cursor: pointer;
    }

    .target-field{
        cursor: pointer;
        font-weight: bold;
        text-decoration: underline;
    }

    .target-field-out-of-service{
        color: red;
    }
</style>